import { TFloorParams } from 'common/types/floor-params.type';

export const getAreaUser = (inputParams: TFloorParams) => {
  if (inputParams.areaUser) {
    return inputParams.areaUser;
  }
  const { length, width } = inputParams;
  if (length && width) {
    return length * width;
  }
  return 0;
};
